export const getAllCoursesAdminQuery = `

query getAllCoursesAdminQuery($workspaceIds: [Int], $postTypeId: Int, $active: Boolean, $published: Boolean, $orderBy: OrderByEnum) {
  Courses(postTypeId: $postTypeId, perpage: 1000, workspaceIds: $workspaceIds, published: $published, active: $active, orderby: $orderBy) {
    items {
      postid
      postviewallhead
      title
      active
      published
      datepublished
      traits {
        internalname
      }
      creator {
        uid
      }
    }
  }
}
`;
